<script>
import Horizontal from './horizontal';

export default {
  components: {
    Horizontal,
  },
  data() {
    return {};
  },
};
</script>

<template>
  <div>
    <Horizontal>
      <slot />
    </Horizontal>
  </div>
</template>
